<form id="userEditForm" [formGroup]="userEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="firstname" class="control-label required">{{ 'i18n.base.user-add-modal.firstname' | translate }}</label>
      <input id="firstname" name="firstname" type="text" class="form-control" formControlName="firstname" />
      <app-error-messages [control]="formFields.firstname"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="lastname" class="control-label required">{{ 'i18n.base.user-add-modal.lastname' | translate }}</label>
      <input id="lastname" name="lastname" type="text" class="form-control" formControlName="lastname" />
      <app-error-messages [control]="formFields.lastname"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="email" class="control-label required">{{ 'i18n.base.user-add-modal.email' | translate }}</label>
      <input id="email" name="email" type="email" class="form-control" formControlName="email" />
      <app-error-messages [control]="formFields.email"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    @if (!hideClient()) {
      <div class="form-group col-md-6">
        <label class="control-label required">{{ 'i18n.base.user-management.column-headers.client' | translate }}</label>
        <app-client-autocomplete class="client-autocomplete" formControlName="client"
          placeholder=""></app-client-autocomplete>
      </div>
    }
    <div class="form-group col-md-{{hideClient()?'12':'6'}}">
      <label class="control-label required">{{ 'i18n.base.user-add-modal.language' | translate }}</label>
      <ejs-dropdownlist [dataSource]="languageDropDowItems"
                        [fields]="languageDropdownSettings"
                        [showClearButton]="true"
                        formControlName="language">
      </ejs-dropdownlist>
      <app-error-messages [control]="formFields.language"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="phoneNumber" [ngClass]="{'control-label required': isMobileUser}">
        {{ 'i18n.base.user-add-modal.phoneNumber' | translate }}
        <span class="required-asterisk"></span>
      </label>
      <input id="phoneNumber" name="phoneNumber" type="text" class="form-control" formControlName="phoneNumber" />
      <app-error-messages [control]="formFields.phoneNumber"></app-error-messages>
    </div>
  </div>
  @if (isMobileUser && !isAdd) {
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label class="d-block">{{ 'i18n.base.user-add-modal.accessCode' | translate }}</label>
        <button class="btn btn-outline-secondary w-100" (click)="generateCode()">
          {{'i18n.base.user-add-modal.accessCodeButton' | translate }}
        </button>
      </div>
      <div class="form-group col-md-6">
        <label>{{ 'i18n.base.user-add-modal.accessCodeValidUntil' | translate }}</label>
        <ejs-tooltip #validUntilToolTip
          content="{{'i18n.base.user-add-modal.accessCodeGeneratedInfo' | translate }}"
          opensOn='custom'>
          <ejs-datepicker formControlName="accessCodeValidUntil" class="dtpkr" format="dd.MM.yyyy"></ejs-datepicker>
        </ejs-tooltip>
        <app-error-messages [control]="formFields.accessCodeValidUntil"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label class="d-block">{{ 'i18n.base.user-add-modal.accessCodeGeneratedOn' | translate }}</label>
        <label>{{userEditForm.value.accessCodeGeneratedOn != null? (userEditForm.value.accessCodeGeneratedOn.toJSDate() | date:'dd.MM.yyyy HH:mm:ss'):""}}</label>
      </div>
      <div class="form-group col-md-6">
        <label class="d-block"> {{ 'i18n.base.user-add-modal.accessCodeUsedOn' | translate}}</label>
        <label>{{userEditForm.value.accessCodeUsedOn != null? (userEditForm.value.accessCodeUsedOn.toJSDate() | date:'dd.MM.yyyy HH:mm:ss'):""}}</label>
      </div>
    </div>
  }
  @if (!isMobileUser && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block control-label required">{{'i18n.base.user-add-modal.role' | translate}}</label>
        <app-button-group [fieldsEnum]="Role"
          id="role"
          [hide]="hiddenRoles"
          formControlName="role"
        [translateKey]="'i18n.shared.enums.Role.'"></app-button-group>
      </div>
    </div>
  }
  @if (!isAdd && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{ 'i18n.base.user-add-modal.enabled' | translate }}</label>
        <app-yes-no-group-button id="enabled" formControlName="enabled"></app-yes-no-group-button>
      </div>
    </div>
  }
</form>
